import { createContext, useContext } from 'react';

interface DataTableContextType {
  sortedColumnHeader?: string;
  setSortedColumnHeader?: (columnHeader: string) => void;
}

export const DataTableContext = createContext<DataTableContextType>({});

export const useDataTableContext = () => {
  return useContext(DataTableContext);
};
